import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { definedSearchParams } from '@/lib/search-params';

import { FeedbackScreen } from './FeedbackScreen';
import type { FeedbackSearch } from './feedback-search';

const route = getRouteApi('/feedback');

export function FeedbackRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const onSearchChange = useCallback(
    (next: FeedbackSearch) => {
      void navigate({ replace: true, search: () => definedSearchParams(next) });
    },
    [navigate],
  );

  const onOpenUser = useCallback(
    (userId: string) => {
      // A push, not a replace: the back button returns to the queue.
      void navigate({ to: '/users/$userId', params: { userId }, search: { tab: 'profile' } });
    },
    [navigate],
  );

  return <FeedbackScreen search={search} onSearchChange={onSearchChange} onOpenUser={onOpenUser} />;
}
